/* Galactic Fireworks - header countdown pill.
   Self-contained: no dependency on theme.js or initLazyScript, because this
   element is above the fold and must tick immediately. */
if (!customElements.get('header-countdown')) {
  class HeaderCountdown extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      // Liquid's %z emits "+0000"; Safari wants "+00:00". Normalise before parsing.
      const raw = (this.dataset.endDate || '').trim();
      const normalised = raw.replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
      this.endDate = new Date(normalised).getTime();

      if (!this.endDate || Number.isNaN(this.endDate)) {
        this.hidden = true;
        return;
      }

      // Desktop zero-pads to keep the boxed cells a stable width. Mobile is left
      // exactly as it was ("7m", not "07m") - James signed that layout off as is.
      this.pad = this.classList.contains('header-countdown--desktop');

      this.daysEl = this.querySelector('.js-cd-days');
      this.hoursEl = this.querySelector('.js-cd-hours');
      this.minsEl = this.querySelector('.js-cd-mins');
      this.secsEl = this.querySelector('.js-cd-secs');
      if (!this.daysEl || !this.hoursEl || !this.minsEl || !this.secsEl) return;

      this.tick();
      this.interval = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    tick() {
      const diff = this.endDate - Date.now();

      if (diff <= 0) {
        clearInterval(this.interval);
        if (this.dataset.hideOnEnd === 'true') {
          this.hidden = true;
          return;
        }

        // Match what the server would render for an elapsed timer, so a page held open
        // across the deadline agrees with a page loaded one second later: end_text if
        // there is any, otherwise nothing at all (an empty pill is still a styled
        // lozenge in the header).
        const endText = (this.dataset.endText || '').trim();
        if (!endText) {
          this.hidden = true;
          return;
        }

        this.classList.add('header-countdown--ended');
        this.textContent = '';
        const span = document.createElement('span');
        span.className = 'header-countdown__label';
        span.textContent = endText;
        this.appendChild(span);
        this.setAttribute('aria-label', endText);
        return;
      }

      const second = 1000;
      const minute = 60 * second;
      const hour = 60 * minute;
      const day = 24 * hour;

      const fmt = (n) => (this.pad ? String(n).padStart(2, '0') : String(n));

      this.daysEl.textContent = fmt(Math.floor(diff / day));
      this.hoursEl.textContent = fmt(Math.floor((diff % day) / hour));
      this.minsEl.textContent = fmt(Math.floor((diff % hour) / minute));
      this.secsEl.textContent = fmt(Math.floor((diff % minute) / second));
    }
  }

  customElements.define('header-countdown', HeaderCountdown);
}
